import { Typography } from 'antd'
import React, { FunctionComponent } from 'react'

import { DRAWER_TYPE } from '../../../redux/drawerSlice'
import { useAppSelector } from '../../../redux/hooks'
import { lvDetailPath } from '../../utils/paths'

export interface LvDetailDrawerTitleProps {
  cadastralName?: string
}

const { Title } = Typography
const titleStyle = { marginBottom: 0 }

export const LvDetailDrawerTitle: FunctionComponent<LvDetailDrawerTitleProps> =
  props => {
    const lv = useAppSelector(state => state.drawer?.[DRAWER_TYPE.LV])

    if (!lv?.lvCode || !lv.lvNumber) {
      return null
    }
    return (
      <a
        href={lvDetailPath(lv.lvCode, lv.lvNumber)}
        target="_blank"
        rel="noreferrer"
        title="Přejít na detail LV v novém okně"
      >
        <Title
          level={4}
          style={titleStyle}
          className="hover:!text-primaryHover transition-colors first-letter:uppercase"
        >
          LV {lv.lvNumber} - {props.cadastralName} ({lv.lvCode})
        </Title>
      </a>
    )
  }
